import { useParams } from "react-router-dom";

import db from "astrid-firebase/src/db";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import OrderView from "../../../orders/views/OrderView/OrderView";

// Shown under its producer, whose finance email the order is sent to.
export default function SuperAdminCloudOrderView() {
	const { id } = useParams();

	const [order, loadingOrder, orderError] = useDocumentData(id && db.collection("orders").doc(id));

	const producerId = order?.firstParty?.id;

	const [producer, loadingProducer, producerError] = useDocumentData(
		producerId && db.collection("organizations").doc(producerId),
	);

	return (
		<LoadingContext data={producer} loading={loadingOrder || loadingProducer} error={orderError || producerError}>
			{producer && <OrderView id={id} organization={producer} enableInvoices={false} />}
		</LoadingContext>
	);
}
